// Concierge availability helper.
// Fetches `GET /api/concierge/availability` once per SPA session and caches
// the result. The endpoint is anonymous and lightweight — used by the
// landing page to decide whether to render the Concierge fork CTA.
//
// Behaviour:
//   * Never throws. On error, returns `{ enabled: false }`.
//   * Cached in module scope — second caller awaits the in-flight promise.
//   * `refresh()` forces a re-fetch (mostly for tests / dev tooling).

import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

let _cache = null;
let _inFlight = null;

async function _fetch() {
  try {
    const res = await axios.get(`${API}/api/concierge/availability`, { timeout: 4000 });
    const enabled = !!(res?.data?.enabled);
    _cache = { enabled };
  } catch (_e) {
    _cache = { enabled: false };
  }
  return _cache;
}

export function getConciergeAvailability() {
  if (_cache) return Promise.resolve(_cache);
  if (_inFlight) return _inFlight;
  _inFlight = _fetch().finally(() => { _inFlight = null; });
  return _inFlight;
}

export function refreshConciergeAvailability() {
  _cache = null;
  _inFlight = null;
  return getConciergeAvailability();
}
